import React, { useEffect, useState, useRef } from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { OTPInputComponent } from "../../../web/Auth/OTPInputComponent";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useDispatch } from "react-redux";
import {
  getUser,
  requestMobileVerification,
  verifyEmail,
  verifyMobileNumber,
} from "services";
import { Button } from "../../../../shadcn/components/ui/button";
import { setBidderUser, setUser } from "store";
interface BidderOTPInputModalProps {
  isEmail: boolean;
  inputModelOpen: any;
  setInputModalOpen: any;
  userIdentity: string;
}

export default function BidderOTPInputModal({
  isEmail,
  inputModelOpen,
  setInputModalOpen,
  userIdentity,
}: BidderOTPInputModalProps) {
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    return () => {
      isSubmittingRef.current = false;
    };
  }, []);

  const form = useBetaForm({
    user_identity: "",
    token: "",
  });
  const form_constraints = {
    user_identity: {
      presence: {
        allowEmpty: false,
      },
    },
    token: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setField("user_identity", userIdentity);
    form.setValidationRules(form_constraints);
  }, [userIdentity]);

  useEffect(() => {
    let countdown: NodeJS.Timeout | null = null;

    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (countdown) clearInterval(countdown);
    };
  }, [timer]);

  const handleResendOTP = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setResendLoading(true);
    try {
      setTimer(60);
      await requestMobileVerification(form);
    } catch (error) {
      console.log("check here error", error);
    } finally {
      isSubmittingRef.current = false;
      setResendLoading(false);
    }
  };

  const handleVerification = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setLoading(true);
    try {
      if (form.validate()) {
        if (!isEmail) {
          const data: any = await verifyMobileNumber({
            value: form.getField("user_identity"),
            otp: form.getField("token"),
          }).then(async (res: any) => {
            setInputModalOpen(false);
          });
        } else {
          await verifyEmail({
            value: form.getField("user_identity"),
            otp: form.getField("token"),
          }).then(async (res: any) => {
            setInputModalOpen(false);
          });
        }
        const user: any = await getUser();
        dispatch(setUser(user));
        dispatch(setBidderUser(user));
      }
    } catch (error: any) {
      console.log("check here error", error);
    } finally {
      isSubmittingRef.current = false;
      setLoading(false);
    }
  };

  return (
    <CustomModalLayout
      open={inputModelOpen}
      className={`pt-8 pb-[30px] min-h-[583px] `}
      childrenClassName="pl-4 pr-6"
      onClose={() => setInputModalOpen(false)}
    >
      <div className="h-full flex flex-col flex-grow">
        <div>
          <p
            className={`font-openSans font-semibold text-center text-[24px] leading-8 text-black `}
          >
            {isEmail ? "Verify your email" : "Verify your number"}
          </p>
          <div className="flex space-x-2 mt-[45px]">
            <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-textGrey">
              OTP sent to{" "}
              <strong className="font-semibold">
                {form.getField("user_identity")}
              </strong>
            </p>
            <button
              className="underline"
              onClick={() => {
                setInputModalOpen(false);
              }}
            >
              Edit
            </button>
          </div>
          <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack mt-8">
            Verify OTP
          </p>
          <div className="w-full flex justify-center mt-2">
            <OTPInputComponent
              otpEntered={form.getField("token")}
              setOtpEntered={(v) => form.setField("token", v)}
            />
          </div>
          {form.errors.get("token") ? (
            <p className="mt-2 text-sm text-red-500">
              {form.errors.get("token")[0]}
            </p>
          ) : null}
          <div className="mt-7 flex items-center font-openSans font-normal text-web-body-sm leading-[18px] text-[#717272] space-x-2">
            <p className="">Didn’t get OTP? </p>
            {timer > 0 ? (
              <p>Resend OTP in {timer} sec</p>
            ) : (
              <button
                className="underline"
                onClick={handleResendOTP}
                disabled={resendLoading}
              >
                {resendLoading ? "Sending..." : "Resend OTP"}
              </button>
            )}
          </div>
        </div>
        <Button
          className="w-full mt-auto mb-[60px]"
          disabled={loading}
          onClick={() => handleVerification()}
        >
          Verify
        </Button>
      </div>
    </CustomModalLayout>
  );
}
